var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-card-foot-item',[_c('core-card-foot-item-value',[(_vm.value)?_c('span',{attrs:{"invalid":!_vm.value},domProps:{"innerHTML":_vm._s(_vm.formatcurrency(_vm.value))}}):_vm._e()]),_c('core-card-foot-item-label',[_vm._v(_vm._s(_vm.field.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }